import { render, staticRenderFns } from "./RightPanelContainerCoordinates.vue?vue&type=template&id=0f694ac8&scoped=true&"
import script from "./RightPanelContainerCoordinates.vue?vue&type=script&lang=js&"
export * from "./RightPanelContainerCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./RightPanelContainerCoordinates.vue?vue&type=style&index=0&id=0f694ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f694ac8",
  null
  
)

export default component.exports